import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

import Button from '../components/Button';

const Content = styled.div`
  padding: ${(props) => props.theme.spacing.gutter};
`;

// See https://reactjs.org/docs/error-boundaries.html
const withErrorBoundary = (WrappedComponent) => {
  class WithErrorBoundary extends Component {
    constructor() {
      super();

      this.state = {
        error: null,
        errorInfo: null,
      };
    }

    componentDidCatch(error, errorInfo) {
      this.setState({
        error,
        errorInfo,
      });
    }

    render() {
      const { error } = this.state;
      const { ...rest } = this.props;

      return (
        <>
          {error ? (
            <Content>
              <Helmet>
                <title>Error</title>
                <meta name="description" content="Something went terribly wrong" />
              </Helmet>
              <h3>Something went terribly wrong</h3>
              <h6>
                <Button width="200px" margin="0 5em" onClick={() => window.location.reload()}>
                  Take me outta here!
                </Button>
              </h6>
            </Content>
          ) : (
            <WrappedComponent {...rest} />
          )}
        </>
      );
    }
  }

  return WithErrorBoundary;
};

export default withErrorBoundary;
